/**
 * Sentry.io logging service
 */

// Raven.config(
//   "https://9271672fc355450f9ce4a86f16c200ce@sentry.io/280913"
// ).install();

export default function log(error, errorInfo) {
  // don't use this anymore, out quota has expired
  //if (process.env.REACT_APP_SERVER) {
  // we're on production, log to sentry
  //Raven.captureException(error, { extra: errorInfo });
  //}
}
